import { useNavigate } from 'react-router-dom';

import { useAppNavigation } from '../../../hooks/useAppNavigation';
import { useMobile } from '../../../hooks/useMobile';

import './navigation-segment.scss';

import Tippy from '@tippyjs/react';

const NavigationSegment = ({
  label,
  route,
  showNotification,
  count,
  icon: Icon,
  onClickOverride,
  tooltip = true
}) => {
  const navigate = useNavigate();
  const { isCurrentRoute } = useAppNavigation();
  const isMobile = useMobile();

  const active = isCurrentRoute(route);

  const handleClick = () => {
    if (onClickOverride) {
      return onClickOverride();
    }

    return navigate(route, { replace: true });
  };

  return (
    <div
      className={`navigation-segment 
    ${active ? 'navigation-segment--active' : ''}
    ${onClickOverride && !isMobile ? 'navigation-segment--clickable' : ''}`}
      onClick={handleClick}
    >
      <div>
        <Tippy content={label} placement="right" disabled={!tooltip || isMobile}>
          <div className="navigation-segment__badge">
            <div className={`${active ? 'navigation-segment__anim-enter' : ''}`} />
            <div className="navigation-segment__image">
              <Icon width={24} heigh={24} />
            </div>
            {showNotification && (
              <div className="navigation-segment__notification">
                <span>{count}</span>
              </div>
            )}
          </div>
        </Tippy>
      </div>
      {((!isMobile && !onClickOverride) || isMobile) && <span>{label}</span>}
    </div>
  );
};

export default NavigationSegment;
